<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <b-button
            variant="outline-primary"
            @click="showTrabajoAdicionalModal = true"
          >
            Registrar Trabajo Adicional
          </b-button>
        </div>
      </template>
    </header-slot>
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(tab, index) in tabs"
        :key="index"
        :to="{ name: tab.name }"
        exact
        :class="isActiveTab(index)"
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ tab.title }}</b-nav-item
      >
    </b-nav>

    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>

    <TrabajoAdicionalModal
      v-if="showTrabajoAdicionalModal"
      :mostrarEmpleados="true"
      @close="showTrabajoAdicionalModal = false"
      @created="handleCreated"
    />
  </div>
</template>


<script>
import Ripple from "vue-ripple-directive";
import TrabajoAdicionalModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalModal.vue";

export default {
  components: {
    TrabajoAdicionalModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      varPrueba: false,
      showTrabajoAdicionalModal: false,
    };
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.matched[2].name;
    },
  },
  methods: {
    isActiveTab(tab) {
      if (tab == 0 && this.routeName == "rrhh-trabajo-adicional-solicitudes") {
        return true;
      }
      return false;
    },
    solicitarAumentoSueldo() {
      this.$refs["routerViewTab"].solicitarAumentoSueldo();
    },
    handleCreated() {
      this.$refs["routerViewTab"].refreshTable();
    },
  },
};
</script>